import styled, { keyframes } from "styled-components";

// Animations
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

/* HERO */
export const Hero = styled.section`
  background: linear-gradient(135deg, #1a1a1a 0%, #2c2c2c 50%, #1a1a1a 100%);
  padding: 2.5rem 0 4rem 0;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="%23ff6b35" opacity="0.1"/><circle cx="75" cy="75" r="1.5" fill="%23ff6b35" opacity="0.1"/><circle cx="50" cy="10" r="0.8" fill="%23ff6b35" opacity="0.1"/><circle cx="10" cy="60" r="1.2" fill="%23ff6b35" opacity="0.1"/><circle cx="90" cy="30" r="0.9" fill="%23ff6b35" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    opacity: 0.3;
    z-index: 1;
  }
`;
export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 300px;
  height: 100%;
  max-height: 300px;
  @media (max-width: 768px) {
    max-width: 250px;
    max-height: 250px;
    margin-bottom: 1rem;
  }
  @media (max-width: 410px) {
    max-width: 200px;
    max-height: 200px;
    margin-bottom: 1rem;
  }
`;

export const HeroContent = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
  z-index: 2;
  position: relative;
  align-items: center;
  display: flex;
  flex-direction: column;

  h1 {
    font-size: 4rem;
    margin-bottom: 1.5rem;
    color: #ff6b35;

    text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5);
    letter-spacing: 2px;
    font-weight: bold;
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: 2.5rem;
    }
  }

  p {
    font-size: 1.4rem;
    margin-bottom: 2rem;
    color: #ffffff;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    opacity: 0.9;

    @media (max-width: 768px) {
      font-size: 1.1rem;
    }
  }
`;

export const HeroStats = styled.div`
  display: flex;
  justify-content: center;
  gap: 3rem;
  margin: 2rem 0;

  .stat {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #ff6b35;
    font-weight: bold;
    font-size: 1.1rem;

    svg {
      font-size: 1.2rem;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;

    .stat {
      justify-content: center;
    }
  }
`;

export const HeroButtons = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 3rem;
`;

export const BtnPrimary = styled.a`
  background: linear-gradient(135deg, #ff6b35, #ff8c42);
  color: #ffffff;
  padding: 1.2rem 2.5rem;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  border: none;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 35px rgba(255, 107, 53, 0.4);
    background: linear-gradient(135deg, #e55a2b, #ff6b35);
  }
`;

export const BtnSecondary = styled.a`
  background: transparent;
  color: #ffffff;
  padding: 1.2rem 2.5rem;
  border: 2px solid #ffffff;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    background: #ffffff;
    color: #1a1a1a;
    transform: translateY(-3px);
    box-shadow: 0 15px 35px rgba(255, 255, 255, 0.2);
  }
`;

/* SECTIONS */
export const Section = styled.section`
  padding: 5rem 0;
  background: ${(props) => props.$bg || "transparent"};
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="%23ff6b35" opacity="0.1"/><circle cx="75" cy="75" r="1.5" fill="%23ff6b35" opacity="0.1"/><circle cx="50" cy="10" r="0.8" fill="%23ff6b35" opacity="0.1"/><circle cx="10" cy="60" r="1.2" fill="%23ff6b35" opacity="0.1"/><circle cx="90" cy="30" r="0.9" fill="%23ff6b35" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    opacity: 0.3;
    z-index: 1;
  }
`;

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  z-index: 2;
  padding: 0 20px;
  position: relative;
`;

export const SectionTitle = styled.h2`
  font-size: 3rem;
  text-align: center;
  margin-bottom: 1rem;
  color: #ff6b35;
  font-weight: bold;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  &::after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 4px;
    background: linear-gradient(135deg, #ff6b35, #ff8c42);
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    font-size: 2.2rem;
    flex-direction: column;
    margin-bottom: 1.5rem;
    gap: 0rem;
  }
`;

export const SectionSubtitle = styled.p`
  text-align: center;
  color: #cccccc;
  font-size: 1.2rem;
  margin-bottom: 3rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

/* STATS AND QUICK ACTIONS */
export const StatsSection = styled.section`
  padding: 3rem 0;
  background: #0f0f0f;
`;

export const QuickActions = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
`;

export const QuickActionCard = styled.div`
  background: linear-gradient(135deg, #1a1a1a, #2c2c2c);
  border: 1px solid #333;
  border-radius: 15px;
  padding: 2rem 1.5rem;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    border-color: #ff6b35;
    box-shadow: 0 10px 25px rgba(255, 107, 53, 0.2);
  }

  svg {
    font-size: 2.5rem;
    color: #ff6b35;
    margin-bottom: 1rem;
  }

  h3 {
    color: #ffffff;
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
    font-weight: bold;
  }

  p {
    color: #cccccc;
    font-size: 0.9rem;
  }
`;

/* PRODUCT SHOWCASE */
export const ProductShowcase = styled.div`
  display: flex;
  width: 100%;

  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 2rem;
  margin-top: 3rem;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ProductCard = styled.div`
  background: linear-gradient(135deg, #1a1a1a 0%, #333 100%);
  border-radius: 15px;
  padding: 1.5rem;
  border: 1px solid #444;
  transition: all 0.3s ease;
  position: relative;
  height: fit-content;
  overflow: hidden;
  animation: ${fadeIn} 0.6s ease-out;
  max-width: 19rem;
  width: 100%;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #ff6b35, #e55a2b);
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(255, 107, 53, 0.3);
    border-color: #ff6b35;
  }
  @media (max-width: 330px) {
    max-width: 100%;
  }
`;

export const ProductImageContainer = styled.div`
  width: 100%;
  height: 200px;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 1rem;
  background: #222;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const Badge = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background: ${({ variant }) =>
    variant === "discount"
      ? "#e74c3c"
      : variant === "limited"
      ? "#9b59b6"
      : variant === "new"
      ? "#27ae60"
      : "#ff6b35"};
  color: #ffffff;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
  z-index: 10;
`;

export const ProductHeader = styled.div`
  margin-bottom: 1rem;
`;

export const ProductTitle = styled.h4`
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: bold;
  margin: 0 0 0.5rem 0;
  line-height: 1.3;
`;

export const ProductBand = styled.span`
  color: #ff6b35;
  font-size: 0.9rem;
  font-weight: 600;
`;

export const ProductMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  gap: 1rem;
`;

export const ProductMetaItem = styled.div`
  display: flex;
  align-items: center;
`;

export const ProductCategory = styled.span`
  background: rgba(255, 107, 53, 0.2);
  color: #ff6b35;
  padding: 0.3rem 0.6rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ProductPrice = styled.span`
  color: ${(props) => (props.$discounted ? "#888" : "#27ae60")};
  font-weight: bold;
  font-size: ${(props) => (props.$discounted ? "0.9rem" : "1.1rem")};
  text-decoration: ${(props) => (props.$discounted ? "line-through" : "none")};
`;

export const ProductDiscountPrice = styled.span`
  color: #27ae60;
  font-weight: bold;
  font-size: 1.1rem;
`;

export const ProductShortDesc = styled.p`
  color: #cccccc;
  font-size: 0.9rem;
  line-height: 1.4;
  margin: 0 0 1.5rem 0;
`;

/* SIZE SELECTOR */
export const ProductSizes = styled.div`
  color: #ff6b35;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

export const SizeSelector = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
`;

export const SizeOption = styled.button`
  background: ${(props) => (props.$selected ? "#ff6b35" : "#444")};
  color: ${(props) => (props.$selected ? "#ffffff" : "#cccccc")};
  border: 1px solid ${(props) => (props.$selected ? "#ff6b35" : "#666")};
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.65rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: ${(props) => (props.$selected ? "bold" : "normal")};

  &:hover {
    background: ${(props) => (props.$selected ? "#e55a2b" : "#555")};
    border-color: #ff6b35;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #333;
    color: #666;
    border-color: #333;
  }
`;

/* QUANTITY CONTROLS */
export const QuantityControl = styled.div`
  display: flex;
  align-items: center;
  background: #2c2c2c;
  border-radius: 10px;
  border: 2px solid #444;
  overflow: hidden;
  max-height: 2rem;
  width: fit-content;
`;

export const QuantityBtn = styled.button`
  background: transparent;
  color: #ffffff;
  border: none;
  padding: 1rem;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.3s ease;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;

  &:hover {
    background: #ff6b35;
  }

  &:disabled {
    color: #666;
    cursor: not-allowed;
    background: transparent;
  }
`;

export const QuantityInput = styled.input`
  background: transparent;
  color: #ffffff;
  border: none;
  padding: 1rem;
  width: 40px;
  text-align: center;
  font-weight: bold;
  font-size: 0.8rem;

  &:focus {
    outline: none;
  }

  &:disabled {
    color: #666;
  }
`;

/* PRODUCT ACTIONS */
export const ProductActions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  flex-wrap: wrap;
`;

export const Button = styled.button`
  padding: 0.8rem 1.2rem;
  min-height: 3rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: ${(props) => {
    switch (props.variant) {
      case "primary":
        return "#ff6b35";
      case "secondary":
        return "#666";
      case "danger":
        return "#e74c3c";
      case "success":
        return "#27ae60";
      default:
        return "#ff6b35";
    }
  }};
  color: #ffffff;

  &:hover {
    background: ${(props) => {
      switch (props.variant) {
        case "primary":
          return "#e55a2b";
        case "secondary":
          return "#555";
        case "danger":
          return "#c0392b";
        case "success":
          return "#229954";
        default:
          return "#e55a2b";
      }
    }};
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

/* BANDS */
export const BandsGrid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 3rem;
  width: 100%;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const BandCard = styled.div`
  background: linear-gradient(135deg, #2c2c2c 0%, #1a1a1a 100%);
  border-radius: 20px;
  padding: 2.5rem 2rem;
  text-align: center;
  transition: all 0.4s ease;
  border: 1px solid #333;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  max-width: 320px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      var(--accent-color, #ff6b35),
      transparent
    );
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 25px 50px var(--accent-shadow, #ff6b3520);
    border-color: var(--accent-color, #ff6b35);

    &::before {
      opacity: 0.1;
    }
  }

  .band-logo {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: var(--accent-color, #ff6b35);
    margin: 0 auto 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: bold;
    font-size: 1.2rem;
  }

  h3 {
    color: #ffffff;
    font-size: 1.4rem;
    margin-bottom: 0.5rem;
    font-weight: bold;
  }

  .genre {
    color: var(--accent-color, #ff6b35);
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .products {
    color: #cccccc;
    margin-bottom: 1.5rem;
  }

  .cta {
    color: var(--accent-color, #ff6b35);
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    opacity: 0;
    transform: translateY(10px);
    transition: all 0.3s ease;
  }

  &:hover .cta {
    opacity: 1;
    transform: translateY(0);
  }
  @media (max-width: 330px) {
    max-width: 100%;
  }
`;

/* TESTIMONIALS */
export const TestimonialsSection = styled.section`
  padding: 5rem 0;
  background: #2c2c2c;
  text-align: center;
  position: relative;

  .testimonial-dots {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 2rem;

    button {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      border: none;
      background: #666;
      cursor: pointer;
      transition: all 0.3s ease;

      &.active {
        background: #ff6b35;
        transform: scale(1.2);
      }
    }
  }
`;

export const TestimonialCard = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const TestimonialContent = styled.div`
  background: linear-gradient(135deg, #1a1a1a, #333);
  border: 1px solid #444;
  border-radius: 20px;
  padding: 3rem;
  position: relative;

  .rating {
    display: flex;
    justify-content: center;
    gap: 0.3rem;
    margin-bottom: 1.5rem;
  }

  p {
    color: #ffffff;
    font-size: 1.3rem;
    line-height: 1.6;
    margin-bottom: 2rem;
    font-style: italic;
  }
`;

export const TestimonialAuthor = styled.div`
  strong {
    color: #ff6b35;
    font-size: 1.1rem;
    display: block;
    margin-bottom: 0.3rem;
  }

  span {
    color: #cccccc;
    font-size: 0.9rem;
  }
`;

/* CATEGORIES */
export const CategoriesGrid = styled.div`
  display: flex;
  width: 100%;

  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 2rem;
  margin-top: 3rem;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const CategoryCard = styled.div`
  background: linear-gradient(135deg, #1a1a1a 0%, #333 100%);
  border-radius: 20px;
  padding: 2.5rem 2rem;
  text-align: center;
  transition: all 0.4s ease;
  border: 1px solid #444;
  cursor: pointer;
  position: relative;
  max-width: 280px;
  width: 100%;
  overflow: hidden;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      var(--category-color, #ff6b35),
      transparent
    );
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px var(--category-shadow, #ff6b3520);
    border-color: var(--category-color, #ff6b35);

    &::before {
      opacity: 0.1;
    }
  }

  h3 {
    color: #ffffff;
    margin: 1.5rem 0 1rem;
    font-size: 1.3rem;
    font-weight: bold;
  }

  p {
    color: #cccccc;
    margin-bottom: 1rem;
    line-height: 1.5;
  }

  .count {
    color: var(--category-color, #ff6b35);
    font-weight: bold;
    margin-bottom: 1.5rem;
  }

  .category-cta {
    color: var(--category-color, #ff6b35);
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    opacity: 0;
    transform: translateY(10px);
    transition: all 0.3s ease;
  }

  &:hover .category-cta {
    opacity: 1;
    transform: translateY(0);
  }
  @media (max-width: 330px) {
    max-width: 100%;
  }
`;

/* LATEST NEWS */
export const LatestNews = styled.section`
  padding: 5rem 0;
  background: #1a1a1a;
`;
export const EmptyBox = styled.div`
  text-align: center;
  color: #ccc;
  padding: 3rem;
  font-size: 1.1rem;
  min-height: 300px;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const NewsGrid = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 2rem;
  margin-top: 3rem;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const NewsCard = styled.div`
  background: linear-gradient(135deg, #2c2c2c, #1a1a1a);
  border: 1px solid #333;
  border-radius: 15px;
  padding: 2rem;
  transition: all 0.3s ease;
  cursor: pointer;

  max-width: 432px;
  width: 100%;
  &:hover {
    border-color: #ff6b35;
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(255, 107, 53, 0.2);
  }

  .news-date {
    color: #ff6b35;
    font-size: 0.9rem;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  h3 {
    color: #ffffff;
    font-size: 1.2rem;
    margin-bottom: 1rem;
    font-weight: bold;
    line-height: 1.3;
  }

  p {
    color: #cccccc;
    line-height: 1.5;
    margin-bottom: 1.5rem;
  }

  .read-more {
    color: #ff6b35;
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.3s ease;
  }

  &:hover .read-more {
    gap: 1rem;
  }
  @media (max-width: 330px) {
    max-width: 100%;
  }
`;

/* FEATURES */
export const FeaturesGrid = styled.div`
  gap: 3rem;
  text-align: center;
  margin-top: 3rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 1200px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const FeatureCard = styled.div`
  padding: 2rem;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  h3 {
    color: #ffffff;
    margin-bottom: 1rem;
    font-size: 1.3rem;
    font-weight: bold;
  }

  p {
    color: #cccccc;
    line-height: 1.6;
  }
`;

export const FeatureIcon = styled.div`
  font-size: 3.5rem;
  color: #ff6b35;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
`;

/* NEWSLETTER */
export const NewsletterWrapper = styled.section`
  background: linear-gradient(135deg, #1a1a1a 0%, #ff6b35 100%);
  text-align: center;
  padding: 5rem 0;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="25" cy="25" r="2" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="1.5" fill="white" opacity="0.1"/><circle cx="50" cy="10" r="1" fill="white" opacity="0.1"/></svg>');
    opacity: 0.3;
  }

  h2 {
    font-size: 3rem;
    margin-bottom: 1rem;
    color: #ffffff;
    font-weight: bold;
    position: relative;
    z-index: 2;

    @media (max-width: 768px) {
      font-size: 2.2rem;
    }
  }

  p {
    font-size: 1.2rem;
    margin-bottom: 2rem;
    color: #ffffff;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    opacity: 0.9;
    position: relative;
    z-index: 2;
  }
`;

export const NewsletterForm = styled.form`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  position: relative;
  z-index: 2;

  input {
    padding: 1.2rem 1.5rem;
    border: none;
    border-radius: 50px;
    font-size: 1rem;
    width: 350px;
    max-width: 100%;
    background: rgba(255, 255, 255, 0.9);

    &:focus {
      outline: none;
      background: #ffffff;
    }
  }
`;
export const NewsletterButton = styled.button`
  padding: 1.2rem 2rem;
  background: #1a1a1a;
  color: #ffffff;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: bold;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    background: ${(props) => (props.disabled ? "#1a1a1a" : " #333")};
    transform: ${(props) => (props.disabled ? "none" : "translateY(-2px)")};
    box-shadow: ${(props) =>
      props.disabled ? "none" : "0 10px 25px rgba(0, 0, 0, 0.3)"};
  }
`;

export const PrivacyNote = styled.p`
  color: #ffffff;
  font-size: 0.9rem;
  opacity: 0.8;
  position: relative;
  z-index: 2;
`;
